export default __webpack_public_path__ + "static/media/필라테스_모바일.95aa851b.jpg";